import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from '../../shared/api/authentication/authentication.service';
import {Router} from '@angular/router';
import {UserService} from '../../shared/api/resources/user/user.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(private _router: Router, private _authenticationService: AuthenticationService, private _userService: UserService) { }

  ngOnInit() {
  }

  logout() {
    this._authenticationService.logout().subscribe(
      (res: any) => {
        if (res.isSuccessStatusCode) {
          this._userService.destroy();
          // we dont do this anymore, we whant to always redirect to the logoutUrl even if it is in stage or dev
          // if (environment.production) {
          //   window.location.href = environment.logoutUrl;
          // } else {
          //   this._router.navigateByUrl('login');
          // }
          window.location.href = environment.logoutUrl;
        } else {
          console.error('Error while logging out.');
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/header/logout/logout.component.ts